import { combineEpics } from "redux-observable";
import { epicGoogleTagMangerLevelUp } from "./epicGoogleTagMangerLevelUp";
import { epicGoogleTagMangerOfferPurchase } from "./epicGoogleTagMangerOfferPurchase";
import { epicGoogleTagMangerShopVisit } from "./epicGoogleTagMangerShopVisit";
export var epicGoogleTagManger = combineEpics(epicGoogleTagMangerLevelUp, epicGoogleTagMangerShopVisit, epicGoogleTagMangerOfferPurchase);



//////////////////
// WEBPACK FOOTER
// ./src/features/google-tag-manager/epicGoogleTagManger.ts
// module id = 1885
// module chunks = 3